<template>
  <div :class="[$style.component, hasDraggedSomething && $style.gameStarted]" ref="boardRef">
    <template v-if="boardRef">
      <template v-if="help">
        <div
          :class="$style.helpToggle"
          @click="helpVisible = !helpVisible"
        >
          ?
        </div>
        <div
          v-if="helpVisible"
          ref="helpRef"
          :class=" [
            'animate__animated',
            isMobile ? 'animate__slideInDown' : 'animate__slideInRight',
            $style.help
          ]"
          @click="helpVisible = false"
        >
          <div
            :class="$style.textContainer"
          >
            <div
              :class="$style.text"
            >
              <div
                v-if="help.title"
                :class="$style.title"
              >
                {{help.title}}
              </div>
              {{help.text}}
            </div>
          </div>
          <img
            :class="$style.snail"
            src="../assets/help-snail.svg"
          />
        </div>
      </template>
      <template
        v-for="(item, index) in items"
      >
        <template v-if="item.type === 'drag'">
          <DragItem
            v-bind="item"
            :keepVisible="hasDoneButton ? true : item.keepVisible"
            :ref="`item_${item.id}`"
            :key="index"
            :placedToRef="placedItems[item.id] ? placedItems[item.id].ref : undefined"
            :initialPosition="item.position ? positionToPixels(item.position) : undefined"
            :size="sizeToPixels(item.size)"
            :boardRef="boardRef"
            :canMovePlaced="hasDoneButton"
            @stop="checkIfItemPlaced(item)"
            @start="stopInitialAnimations"
            :class="[
              'animate__animated',
              item.id === itemIsShaking && 'animate__tada',
              $style.dragItem
            ]"
          />
        </template>
        <template v-else-if="item.type === 'drop'">
          <DropItem
            v-bind="item"
            :ref="`item_${item.id}`"
            :key="index"
            :position="positionToPixels(item.position)"
            :size="sizeToPixels(item.size)"
            :boardRef="boardRef"
          />
        </template>
        <template v-else-if="item.type === 'doneButton'">
          <ButtonItem
            :key="index"
            :ref="`item_${item.id}`"
            :position="positionToPixels(item.position)"
            :boardRef="boardRef"
            :errorLabel="isIncorrectAnswer ? 'Väärä järjestys.\nKokeile uudestaan!' : undefined"
            @click="checkIfAllPlaced"
          >
            Valmis
          </ButtonItem>
        </template>
        <template v-else>
          <VisualItem
            v-bind="item"
            :ref="`item_${item.id}`"
            :key="index"
            :position="positionToPixels(item.position)"
            :size="sizeToPixels(item.size)"
            :labelType="item.labelType"
            :labelSize="item.labelSize"
            :boardRef="boardRef"
          />
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'

import useWindowResize from '@/composition/useWindowResize'
import useIntervals from '@/composition/useIntervals'
import {getStars} from '@/utils/stars'

export default {
  props: {
    items: {type: Array, required: true},
    help: {type: Object, required: false},
  },
  setup (props, context) {
    const windowWidth = ref(window.innerWidth)
    const placedItems = ref({})
    const boardRef = ref()
    const boardSize = ref()
    const droppedToPlaceCount = ref(0)
    const droppedToCorrectPlaceCount = ref(0)
    const doneButtonClickedTimes = ref(0)
    const hasDraggedSomething = ref(false)
    const itemIsShaking = ref(undefined)
    const setInterval = useIntervals()
    const isIncorrectAnswer = ref(false)
    const hasDoneButton = computed(() => (
      !!props.items.find(item => item.type === 'doneButton')
    ))
    const helpRef = ref()
    const helpVisible = ref(false)

    // useZoom(helpRef, 1.0)

    watch(placedItems, placed => {
      console.log('\n')
      Object.values(placed).forEach(val => {
        console.log(val.dragItem.id, 'is in', val.dropItem.id, val.ref.$attrs.id)
      })
    })

    useWindowResize(() => {
      windowWidth.value = window.innerWidth
      updateBoardSize()
      for (const item of props.items) {
        const [itemRef] = context.refs[`item_${item.id}`]
        if (itemRef.refreshPosition) itemRef.refreshPosition()
      }
    })

    watch(boardRef, boardRef => {
      updateBoardSize()
    })

    setTimeout(() => {
      for (const item of props.items) {
        if (item.startAtDropItem) {
          const dragItem = item
          const dropItem = props.items.find(({id}) => item.startAtDropItem === id)
          const [dragItemRef] = context.refs[`item_${dragItem?.id}`]
          const [dropItemRef] = context.refs[`item_${dropItem?.id}`]
          if (dragItem && dropItem && dropItemRef) {
            placedItems.value[item.id] = {
              dragItem,
              dropItem,
              ref: dropItemRef,
            }
            const {
              offsetLeft: dropToItemLeft,
              offsetTop: dropToItemTop,
            } = dropItemRef.$el
            dragItemRef.setPosition(dropToItemLeft, dropToItemTop)
            placedItems.value = {...placedItems.value}
          }
        }
      }
    })

    const shakeIntervalId = setInterval(() => {
      const dragItems = props.items.filter((item) => item.type === 'drag')
      const randomIndex = Math.floor(Math.random() * dragItems.length)

      itemIsShaking.value = dragItems[randomIndex].id
    }, 2500)

    return {
      itemIsShaking,
      hasDraggedSomething,
      placedItems,
      boardRef,
      checkIfAllPlaced,
      hasDoneButton,
      isIncorrectAnswer,
      helpVisible,
      helpRef,
      isMobile: computed(() => windowWidth.value < 600),
      positionToPixels (vals) {
        if (!boardSize.value) return vals

        return vals.map((val, index) => {
          if (typeof val !== 'number' || !boardSize.value[index]) return val

          return (val / 100) * boardSize.value[index]
        })
      },
      sizeToPixels (vals) {
        return vals.map((val, index) => {
          if (typeof val !== 'number') return val
          return (val / 100) * 1024
        })
      },
      checkIfItemPlaced (item) {
        const [itemRef] = context.refs[`item_${item.id}`]
        const {offsetLeft: itemX, offsetTop: itemY} = itemRef.$el
        let wasPlaced = false
        for (const dropToItem of props.items) {
          if (dropToItem.type !== 'drop') continue
          const [dropToItemRef] = context.refs[`item_${dropToItem.id}`]
          const {
            offsetLeft: dropToItemLeft,
            offsetTop: dropToItemTop,
            offsetWidth: dropToItemWidth,
            offsetHeight: dropToItemHeight,
          } = dropToItemRef.$el
          const dropToItemX = dropToItemLeft
          const dropToItemY = dropToItemTop
          const isIndropToItem = (
            Math.abs(dropToItemX - itemX) < dropToItemWidth / 2 &&
            Math.abs(dropToItemY - itemY) < dropToItemHeight / 2
          )
          if (!isIndropToItem) {
            continue
          }

          wasPlaced = true

          const isCorrectDropToItem = dropToItem.id === item.dropTo

          droppedToPlaceCount.value++
          if (isCorrectDropToItem) {
            droppedToCorrectPlaceCount.value++
          }

          if (hasDoneButton.value) {
            const previousPlace = placedItems.value[item.id]
            const previousItemInSamePlace = Object.values(placedItems.value).find(
              ({dropItem}) => dropItem.id === dropToItem.id,
            )

            if (previousItemInSamePlace) {
              if (previousPlace) {
                const [previousItemRef] = context.refs[`item_${previousItemInSamePlace.dragItem.id}`]
                placedItems.value[previousItemInSamePlace.dragItem.id] = {
                  dragItem: previousItemInSamePlace.dragItem,
                  dropItem: previousPlace.dropItem,
                  ref: previousPlace.ref,
                }
                placedItems.value = {...placedItems.value}
                const {
                  offsetLeft: dropToItemLeft,
                  offsetTop: dropToItemTop,
                } = previousPlace.ref.$el
                previousItemRef.goToPlace(dropToItemLeft, dropToItemTop)
              } else {
                const [previousItemRef] = context.refs[`item_${previousItemInSamePlace.dragItem.id}`]
                delete placedItems.value[previousItemInSamePlace.dragItem.id]
                placedItems.value = {...placedItems.value}
                previousItemRef.returnToPlace()
              }
            }

            placedItems.value[item.id] = {dragItem: item, dropItem: dropToItem, ref: dropToItemRef}
            placedItems.value = {...placedItems.value}
            itemRef.goToPlace(dropToItemX, dropToItemY)
          } else {
            if (isCorrectDropToItem) {
              dropToItemRef.animateRight()
              placedItems.value[item.id] = {dragItem: item, dropItem: dropToItem, ref: dropToItemRef}
              placedItems.value = {...placedItems.value}
              checkIfAllPlaced()
            } else {
              itemRef.returnToPlace()
              itemRef.animateWrong()
              dropToItemRef.animateWrong()
            }
          }

          break
        }

        if (!wasPlaced) {
          if (!item.startAtDropItem) {
            itemRef.returnToPlace()
            delete placedItems.value[item.id]
            placedItems.value = {...placedItems.value}
          } else {
            itemRef.returnToPlace()
          }
        }
      },

      stopInitialAnimations () {
        if (hasDraggedSomething.value) return
        hasDraggedSomething.value = true
        clearInterval(shakeIntervalId)
      },
    }

    function updateBoardSize () {
      if (!boardRef.value) return
      const {
        offsetWidth: boardWidth,
        offsetHeight: boardHeight,
      } = boardRef.value
      boardSize.value = [boardWidth, boardHeight]
    }

    function checkIfAllPlaced () {
      const numPlaced = (
        Object.values(placedItems.value).filter(placed => !!placed).length
      )
      const maxPlaced = (
        props.items.filter(item => item.type === 'drag').length
      )
      const allPlacedCorrectly = (
        Object.values(placedItems.value).every(({dragItem, dropItem}) => (
          dragItem.dropTo === dropItem.id
        ))
      )
      if (numPlaced === maxPlaced) {
        doneButtonClickedTimes.value++
        let stars
        if (allPlacedCorrectly) {
          if (hasDoneButton.value) {
            switch (doneButtonClickedTimes.value) {
              case 1:
                stars = 3
                break
              case 2:
                stars = 2
                break
              default:
                stars = 1
                break
            }
          } else {
            stars = getStars(droppedToCorrectPlaceCount.value, droppedToPlaceCount.value)
          }
          context.emit('finish', {
            stars,
          })
        } else {
          isIncorrectAnswer.value = true
        }
      }
    }
  },
}
</script>

<style module lang="scss">
.component {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: stretch;
  margin-left: auto;
  margin-right: auto;
  width: variables.$breakpoint-1024;
  height: 100%;
  max-width: 100%;
}

.helpToggle {
  position: fixed;
  top: 16px;
  right: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  width: 50px;
  height: 50px;
  background-color: white;
  box-shadow: -4px -4px 4px hsl(0deg 0% 100% / 17%), 4px 4px 4px rgb(25 25 25 / 20%);
  cursor: pointer;
  user-select: none;
  z-index: 999;

  @include mixins.l-heading-size;

  @include media.query($from: 780) {
    width: 70px;
    height: 70px;
    right: 102px;
  }
}

.help {
  position: absolute;
  right: 0;
  max-width: 100%;
  top: -30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  animation-duration: 1s;
  z-index: 99;
  background-image: url('../assets/help-background-vertical.svg');
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .textContainer {
    width: 400px;
    height: 0;
    padding-bottom: 60%;
  }

  .text {
    position: absolute;
    top: 10%;
    left: 6px;
    right: 10%;
    bottom: 3%;
    padding: 25px 10px 15px 25px;
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    color: white;

    &::-webkit-scrollbar {
      width: 2px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.5);
    }

    @include mixins.xs-body-size;

    .title {
      margin-bottom: 8px;
      text-transform: uppercase;
      color: #FE9EB9;

      @include mixins.xs-heading-size;
    }
  }

  .snail {
    position: absolute;
    top: -75px;
    left: 30%;
    display: block;
    width: auto;
    height: 75px;
    margin-left: 10px;
    transform: rotateZ(-45deg);
  }

  @include media.query($from: 600) {
    right: 175px;
    top: 0;
    background-image: url('../assets/help-background-horizontal.svg');

    .textContainer {

    }

    .text {
      top: 10px;
      left: 6px;
      right: 45px;
      bottom: 17px;

      padding: 25px 10px 15px 25px
    }

    .snail {
      top: 25px;
      left: auto;
      right: -175px;
      height: auto;
      width: 175px;
      transform: none;
      pointer-events: none;
    }
  }
}
</style>
